import { AxiosInstance } from "axios";
import { toast } from "react-toastify";
export interface TargetsResponse {
  err: string;
  targets: target[];
}

export interface target {
  id: string;
  name: string;
}

export const getTargetsQuery = async (axios: AxiosInstance) => {
  try {
    const response = await axios.post<TargetsResponse>("api2/Trade/Targets");
    if (!response.data) {
      toast.error(`取標的清單Error:not found`, {
        position: "top-right",
        autoClose: 1300,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
      return { err: "9999", targets: [] };
    }
    if (response.data.err !== "0000") {
      toast.warn(`標的清單${"(" + response.data.err + ")"}`, {
        position: "top-right",
        autoClose: 1300,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
      });
    }
    return response.data;
  } catch (error) {
    (window.parent as any).reactLogout(`登入閒置已超過20分鐘，請重新登入。 Error:${error}`);
    return { err: "9999", targets: [] };
  }
};
